import { render, staticRenderFns } from "./ticketTip.vue?vue&type=template&id=a7c6c80a&scoped=true"
import script from "./ticketTip.vue?vue&type=script&lang=js"
export * from "./ticketTip.vue?vue&type=script&lang=js"
import style0 from "./ticketTip.vue?vue&type=style&index=0&id=a7c6c80a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c6c80a",
  null
  
)

export default component.exports